import type { AbsorbedFeeLine } from '../types/financials.types';

type SubtitleInput = Pick<AbsorbedFeeLine, 'schedulingMethod' | 'valueType' | 'percentage' | 'band'>;

const SCHEDULING_TEXT = new Map<string, string>([
    ['Upfront', 'One-off at set-up'],
    ['Monthly', 'per DD'],
    ['Cancellation', 'on Cancellation'],
    ['PerService', 'per service'],
    ['Annual', 'per year'],
    ['OnClaim', 'on claim'],
]);

const PERCENTAGE_BASE_TEXT = new Map<string, string>([
    ['Percentage', 'of services and extras'],
    ['PercentageLookupService', 'of services and extras'],
    ['PercentageTotalNet', 'of plan total (ex VAT)'],
    ['PercentageTotalGross', 'of plan total (inc VAT)'],
]);

const trimPercentage = (value: string): string => (value.includes('.') ? value.replace(/\.?0+$/, '') : value);

const percentagePart = ({ valueType, percentage }: SubtitleInput): string | null => {
    const base = valueType === null ? undefined : PERCENTAGE_BASE_TEXT.get(valueType);
    if (base === undefined || percentage === null) return null;
    return `${trimPercentage(percentage)}% ${base}`;
};

export const absorbedFeeSubtitle = (line: SubtitleInput): string | null => {
    const scheduling = line.schedulingMethod === null ? undefined : SCHEDULING_TEXT.get(line.schedulingMethod);
    const parts = [scheduling, percentagePart(line), line.band === null ? null : `band ${line.band}`].filter(
        (part): part is string => part !== undefined && part !== null,
    );
    return parts.length === 0 ? null : parts.join(' · ');
};
